import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { DbButton } from "@db-ui/v-elements-enterprise/dist/components";

export default /*@__PURE__*/_defineComponent({
  __name: 'DbButton',
  props: {
  variant: {
    type: String as () =>
      | "brand-primary"
      | "primary"
      | "secondary-outline"
      | "secondary-solid"
      | "tertiary-plain"
      | undefined,
    default: "",
  },
  classList: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
    required: false,
  },
},
  emits: ["onClick"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('onClick')), ["prevent"]))
  }, [
    _createVNode(_unref(DbButton), {
      id: __props.id,
      class: _normalizeClass(__props.classList),
      type: "submit",
      variant: __props.variant,
      disabled: __props.disabled
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "class", "variant", "disabled"])
  ], 32))
}
}

})